var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('v-header-admin',{on:{"mobileActive":_vm.mobileActive}}),_c('router-view'),_c('v-footer-admin'),_c('SystemUpdatePopup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }